module.exports = __webpack_public_path__ + "img/filler.2e1d6dcf.jpg";